/**
 * 彙總轉倉 candidates → UI 列（camel）。
 * `transferableInventoryStocks[].stockId` → 選庫列 `id`（寫入用 `invStockId`）。
 *
 * @param {object|null|undefined} data
 */
export function normalizeTransferCandidates(data) {
  const seenMtrIds = new Set();
  const materials = [];

  (data?.materials ?? []).forEach((row) => {
    const mtr = row?.mtr ?? {};
    const mtrId = mtr.id == null || mtr.id === '' ? '' : String(mtr.id);
    if (!mtrId || seenMtrIds.has(mtrId)) {
      return;
    }
    seenMtrIds.add(mtrId);

    const seenStockIds = new Set();
    const transferableInventoryStocks = [];
    (row?.transferableInventoryStocks ?? []).forEach((stock) => {
      const id = stock?.stockId == null || stock.stockId === ''
        ? ''
        : String(stock.stockId);
      if (!id || seenStockIds.has(id)) {
        return;
      }
      seenStockIds.add(id);
      const warehouse = stock?.warehouse ?? {};
      const warehouseLabel = [warehouse.code, warehouse.name]
        .filter(Boolean)
        .join(' - ') || warehouse.name || '';
      transferableInventoryStocks.push({
        id,
        stockNo: stock?.stockNo ?? '',
        warehouseId: warehouse.id == null || warehouse.id === ''
          ? ''
          : String(warehouse.id),
        warehouseLabel,
        locationLabel: '',
        availableQty: stock?.availableQty,
      });
    });

    materials.push({
      mtrId,
      mtrNo: mtr.mtrNo ?? '',
      mtrName: mtr.name ?? '',
      requiredQty: row?.requiredQty,
      onHandQty: row?.onHandQty,
      shortageQty: row?.shortageQty,
      workOrders: row?.workOrders ?? [],
      transferableInventoryStocks,
    });
  });

  return {
    workWarehouse: data?.workWarehouse ?? null,
    materials,
  };
}
